import { gql } from '@apollo/client'

export const bankDataMutation = gql`
  mutation bankInfo($iban: String!, $bic: String) {
    bankInfo(iban: $iban, bic: $bic) {
      success
    }
  }
`
